import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import { showAddInvoiceModalSelector } from 'components/admin/work-orders/details/vendor-invoices/store/selectors';
import { connect } from 'react-redux';
import {
  createVendorInvoice,
  setShowAddInvoiceModal,
} from 'components/admin/work-orders/details/vendor-invoices/store/actions';
import AddVendorInvoiceForm from 'components/admin/work-orders/details/vendor-invoices/AddVendorInvoiceForm';
import { getTasks } from 'selectors/admin/work-orders/work-orders';

class AddVendorInvoiceModal extends Component {
  handleSubmit = (values) => {
    this.props.dispatch(createVendorInvoice(values.taskId, values));
  };

  render() {
    return (
      <FormModal
        title="Add Invoice"
        show={this.props.showAddInvoiceModal}
        onClose={() => this.props.dispatch(setShowAddInvoiceModal(false))}
      >
        <AddVendorInvoiceForm
          tasks={this.props.tasks}
          onSubmit={this.handleSubmit}
        />
      </FormModal>
    );
  }
}

export default connect((state) => {
  return {
    showAddInvoiceModal: showAddInvoiceModalSelector(state),
    tasks: getTasks(state),
  };
})(AddVendorInvoiceModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/vendor-invoices/AddVendorInvoiceModal.js